import { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import { useWeb3React } from '@web3-react/core';
import logo from '../../assets/icons/logo.png';
import home from '../../assets/icons/nav/home.svg';
import inbox from '../../assets/icons/nav/inbox.svg';
import user from '../../assets/icons/nav/profile.svg';
import wallet from '../../assets/icons/nav/wallet.svg';
import homeActive from '../../assets/icons/nav/home-active.svg';
import inboxActive from '../../assets/icons/nav/inbox-active.svg';
import userActive from '../../assets/icons/nav/profile-active.svg';
import walletActive from '../../assets/icons/nav/wallet-active.svg';
import setting from '../../assets/icons/nav/settings.svg';
import menu from '../../assets/icons/menu.svg';
import chainIdTag from '../../assets/icons/chainid-tag.svg';
import help from './../../assets/icons/nav/question-mark.svg';
import bell from './../../assets/icons/nav/notification-bell.svg';
import search from './../../assets/icons/nav/search.svg';
import { Link } from 'react-router-dom';
import { convertToBiobit, toast } from '../../utils';
import MobileMenu from '../MobileMenu';
import NotificationMenu from '../NotificationMenu';
import { mainContext } from './../../state';
import { useLocation } from 'react-router';
import { actionTypes } from '../../state/actionTypes';
import { makeStyles } from '@material-ui/core';
import { useScrollPosition } from '../../hooks/useScrollPosition';
import { Box } from '@material-ui/core';
import TitleBar from '../../components/TitleBar/TitleBar';
import { CURRENT_NETWORK_LABEL } from '../../constants';
import { ThemeButton } from './../Elements/Button';
import { Header as Heading, BodyText } from './../Elements/Typography';
import { Row } from './../Elements/Flex';
import { ThemeIcon } from './../Elements/Icon';
// removed unused Badge import

const NavItem = styled(Link).withConfig({
	shouldForwardProp: (prop) => prop !== 'isMobile',
})`
	position: relative;
	height: 50px;
	display: flex;
	flex-direction: column;
	align-items: center;
	align-content: center;
	justify-content: center;
	text-decoration: none;
	margin-right: ${(props) => (props.isMobile ? props.theme.space[2] : props.theme.space[3])}px;
	margin-left: ${(props) => (props.isMobile ? props.theme.space[2] : props.theme.space[3])}px;
	outline: none !important;
	cursor: ${(props) => props.disabled && 'not-allowed'};
	opacity: ${(props) => (props.disabled ? 0.4 : 1)};
`;

// removed unused NavItemDisabled

// removed unused NavLink

const RightMenu = styled.div`
	display: flex;
	align-items: center;
	flex: 7;
`;

const LeftMenu = styled.div`
	display: flex;
	justify-content: flex-end;
	flex: 5;
`;

const NavIcon = styled.img`
	height: ${(props) => props.height ?? '30px'};
`;

const Logo = styled.img`
	height: 32px;
	margin-left: 20px;
	margin-right: ${(props) => (props.isMobile ? props.theme.spacing(1) : props.theme.spacing(4))};
`;

// removed unused SubmitRequestButton

const HeaderWrapper = styled.header`
	position: sticky;
	top: 0;
	z-index: 2;
	height: ${(props) => (props.isMobile ? '75px' : '100px')};
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-end;
	background: ${(props) => props.theme.colors.bgWhite};
	margin-bottom: ${(props) => (props.routeGroup === '' ? 0 : props.routeGroup === 'request' ? 0 : '130px')};
`;

const HeaderWrapperApp = styled(HeaderWrapper).withConfig({
	shouldForwardProp: (prop) => prop !== 'isMobile',
})`
	position: sticky;
	top: 0;
	z-index: ${(props) => props.theme.z_header};
	padding: 0;
	display: flex;
	flex-direction: column;
	margin-bottom: ${(props) => (props.routeGroup === '' ? '70px' : props.routeGroup === 'request' ? 0 : '100px')};
`;

const NavBarRow = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== 'isMobile',
})`
	max-width: 100vw;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	z-index: 2;
	width: 100%;
	height: 100%;
	background: ${(props) => props.theme.colors.bgWhite};
	height: ${(props) => (props.isMobile ? '70px' : '100px')};
	padding: ${(props) => (props.isMobile ? '10px 18px' : `25px calc((100vw - 1255px) / 2)`)};
	box-shadow: 0px 4px 18px 0px rgb(81 197 234 / 10%);
`;

const LogoApp = styled(Logo)`
	height: 24px;
	margin-left: 0;
`;

const NavIconApp = styled(NavIcon)`
	height: 19.5px;
`;

const ChainBadge = styled.div`
	background-image: url(${chainIdTag});
	background-repeat: no-repeat;
	background-size: 100%;
	position: absolute;
	background-position: center;
	right: -106px;
	top: 14px;
	height: 42px;
	white-space: nowrap;
	padding: 10px 20px;
	padding-right: 10px;
	line-height: 22px;
	color: ${props => props.theme.colors.primary};
`;
const TitleSection = styled.div`
	display: flex;
	height: 83px;
	width: 100%;
	padding: 0 18px;
	justify-content: space-between;
	align-items: center;
	background-color: ${props => props.theme.colors.bgDisabled};
	flex-wrap: wrap;
`;
const Title = styled.h1`
	color: ${props => props.theme.colors.textPrimary};
	font-size: 18px;
	font-weight: 700;
	white-space: nowrap;
	margin-left: 0px;
`;

// removed unused SubmitRequestButtonSubHeader

const BoxWrapper = styled.div`
	position: absolute;
	top: 0;
	z-index: 1;
	width: 100%;
`;

const WalletTitlebar = styled(TitleBar)`
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-between;
	height: ${(props) => (props.isMobile ? '85px' : 'unset')};
	padding: ${(props) => props.isMobile && '0 18px'};
	flex-direction: row;
	width: 100%;
	align-items: center;
`;
const Balance = styled.div`
	font-style: normal;
	font-weight: 500;
	font-size: ${(props) => (props.isMobile ? '14px' : '22px')};
	line-height: ${(props) => (props.isMobile ? '18px' : '29px')};
	color: ${(props) => props.theme.textPrimary};
`;

const RewardWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

const RewardItem = styled.div`
	display: flex;
	justify-content: flex-end;
`;

const RewardLabel = styled.div`
	font-weight: 300;
	font-size: 16px;
	line-height: 21px;

	@media (max-width: 768px) {
		font-size: 12.5px;
	}
`;

const RewardValue = styled.div`
	font-size: 16px;
	font-weight: 700;
	margin-left: ${(props) => props.theme.spacing(1)};

	@media (max-width: 768px) {
		font-size: 13px;
		font-weight: 600;
	}
`;
const NotificationBadge = styled.div`
	min-width: ${(props) => (props.isMobile ? '20px' : '25px')};
	min-height: ${(props) => (props.isMobile ? '20px' : '25px')};
	font-size: ${(props) => (props.isMobile ? '12px' : '16px')};
	background-color: ${props => props.theme.colors.secondary};
	border-radius: ${(props) => (props.isMobile ? '10px' : '16px')};
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${props => props.theme.colors.textLabel};
	position: absolute;
	top: ${(props) => (props.isMobile ? '-3px' : '-10px')};
`;

const useStyles = makeStyles({
	root: {
		boxShadow: '0px 4px 18px 0px rgb(81 197 234 / 10%)',
	},
});

export default function Header({ isMobile }, props) {
	const { account } = useWeb3React();
	const [isMenuOpen, setMenuOpen] = useState(false);
	const [isNotificationMenuOpen, setIsNotificationMenuOpen] = useState(false);

	const { appState, dispatch } = useContext(mainContext);
	const location = useLocation();
	const [sticky, setSticky] = useState(true);
	const [totalRevenueFromZarela, setTotalRevenueFromZarela] = useState(0);
	const [totalRevenueFromRequester, setTotalRevenueFromRequester] = useState(0);
	const routeGroup = location.pathname.split('/')[1];
	const classes = useStyles(props);
	const GUIDES = ['/', '/inbox', '/log', '/request'];

	useEffect(() => {
		if (appState.contract !== null) {
			if (account) {
				// Use promise-based call for Web3 v4 compatibility
				appState.contract.methods.userMap(account).call()
					.then((result) => {
						const formatter = (value) => convertToBiobit(value);
						setTotalRevenueFromRequester(formatter(result[1]));
						setTotalRevenueFromZarela(formatter(result[0]));
					})
					.catch((error) => {
						toast(error.message || 'Error fetching user data', 'error');
					});
			}
		}
	}, [account, appState.contract]);

	useScrollPosition(
		({ prevPos, currPos }) => {
			const isShow = currPos.y > prevPos.y;
			if (isShow !== sticky) setSticky(isShow);
		},
		[sticky]
	);

    useEffect(() => {
        dispatch({
            type: actionTypes.SET_NOTIFICATION_COUNT,
            payload: 0,
        });
    }, [isNotificationMenuOpen, dispatch]);

	if (isMobile) {
		return (
			<>
				<HeaderWrapperApp routeGroup={routeGroup} isMobile={appState.isMobile}>
					<NavBarRow isMobile={appState.isMobile}>
						<RightMenu>
							<Link to="/">
								<LogoApp src={logo} />
							</Link>
						</RightMenu>
						<LeftMenu>
							<NavItem isMobile={appState.isMobile}>
								{GUIDES.find(
									(page) =>
										location.pathname === page ||
										(location.pathname.startsWith(page) && page !== '/')
								) &&
									!location.pathname.startsWith('/inbox') &&
									!location.pathname.startsWith('/request/create') && (
										<NavIcon
											height="20px"
											src={help}
											onClick={() => {
												localStorage.removeItem('guide/' + location.pathname.split('/')[1]);
												dispatch({
													type: actionTypes.SET_GUIDE_IS_OPEN,
													payload: true,
												});
											}}
										/>
									)}
							</NavItem>
							<NavItem isMobile={appState.isMobile}>
								<NavIcon src={bell} height="20px" onClick={() => setIsNotificationMenuOpen(true)} />
								{appState.notificationCount !== 0 && (
									<NotificationBadge isMobile={appState.isMobile}>
										{appState.notificationCount}
									</NotificationBadge>
								)}
							</NavItem>
							<NavItem isMobile={appState.isMobile}>
								<NavIcon src={search} height="20px" onClick={() => 	dispatch({
													type: actionTypes.SET_MOBILE_SEARCH_MODAL_SHOW,
													payload: true,
												})} />
							</NavItem>
							<NavItem isMobile={appState.isMobile}>
								<NavIconApp src={menu} onClick={() => setMenuOpen(true)} />
							</NavItem>
						</LeftMenu>
						<MobileMenu
							isOpen={isMenuOpen}
							onClose={() => {
								setMenuOpen(false);
							}}
						/>

						<NotificationMenu
							appState={appState}
							isOpen={isNotificationMenuOpen}
							onClose={() => {
								setIsNotificationMenuOpen(false);
							}}
						/>
					</NavBarRow>
					<BoxWrapper>
						<Box
							className={classes.root}
							as="header"
							mt="-1em"
							sx={{
								position: 'sticky',
								transform: sticky ? 'translateY(83px)' : 'translateY(0)',
								transition: 'transform 400ms ease-in',
								bottom: 0,
								left: 0,
							}}
						>
							{routeGroup === '' ? (
								<TitleSection>
									<Heading as="h4" variant="heading4">
										Recent requests
									</Heading>
									<ThemeButton variant="primary" size="medium" to="/request/create">
										New Request
									</ThemeButton>
								</TitleSection>
							) : routeGroup === 'wallet' ? (
								<WalletTitlebar isMobile={appState.isMobile}>
									<Heading as="h4" variant="heading4">
										Wallet
									</Heading>
									<Heading
										as="h4"
										variant="heading4"
									>{`Balance: ${appState.biobitBalance} BBit`}</Heading>
								</WalletTitlebar>
							) : routeGroup === 'log' ? (
								<WalletTitlebar isMobile={appState.isMobile}>
									<Heading as="h4" variant="heading4">
										Log
									</Heading>
									<RewardWrapper>
										<RewardItem>
											<BodyText variant="extraSmall">My reward from Zarela</BodyText>
											<BodyText
												variant="extraSmall"
												fontWeight="bold"
												ml={3}
											>{`${totalRevenueFromZarela} BBit`}</BodyText>
										</RewardItem>
										<RewardItem>
											<BodyText variant="extraSmall">My wage from mage</BodyText>
											<BodyText
												variant="extraSmall"
												fontWeight="bold"
												ml={3}
											>{`${totalRevenueFromRequester} BBit`}</BodyText>
										</RewardItem>
									</RewardWrapper>
								</WalletTitlebar>
							) : routeGroup === 'inbox' ? (
								<Heading as="h4" variant="heading4" p={4} bg="bgDisabled">
									Inbox
								</Heading>
							) : routeGroup === 'settings' ? (
								<TitleBar>
									<BodyText variant="extraSmall">Settings</BodyText>
								</TitleBar>
							) : null}
						</Box>
					</BoxWrapper>
				</HeaderWrapperApp>
			</>
		);
	} else {
		return (
			<HeaderWrapper routeGroup={routeGroup} isMobile={appState.isMobile}>
				<NavBarRow isMobile={appState.isMobile}>
					<Row>
						<Link to="/">
							<Logo isMobile={appState.isMobile} src={logo} />
						</Link>
						<NavItem isMobile={appState.isMobile} to="/">
							<ThemeIcon variant="layout" src={routeGroup === '' ? homeActive : home} mr={'0px'} />
							<BodyText
								variant="small"
								fontWeight={routeGroup === '' ? 'semiBold' : 'normal'}
								color="primary"
							>
								Home
							</BodyText>
						</NavItem>
						<NavItem isMobile={appState.isMobile} to="/inbox">
							<ThemeIcon variant="layout" mr={'0px'} src={routeGroup === 'inbox' ? inboxActive : inbox} />
							<BodyText
								variant="small"
								fontWeight={routeGroup === 'inbox' ? 'semiBold' : 'normal'}
								color="primary"
							>
								Inbox
							</BodyText>
						</NavItem>
						<NavItem isMobile={appState.isMobile} to="/log/my_requests">
							<ThemeIcon variant="layout" mr={'0px'} src={routeGroup === 'log' ? userActive : user} />
							<BodyText
								variant="small"
								fontWeight={routeGroup === 'log' ? 'semiBold' : 'normal'}
								color="primary"
							>
								Log
							</BodyText>
						</NavItem>
                        {/* Explore nav item removed */}
						<NavItem isMobile={appState.isMobile} to="/wallet/account">
							<ThemeIcon
								variant="layout"
								m="0 8px"
								src={routeGroup === 'wallet' ? walletActive : wallet}
							/>
							<BodyText
								variant="small"
								fontWeight={routeGroup === 'wallet' ? 'semiBold' : 'normal'}
								color="primary"
							>
								Wallet
							</BodyText>
							<ChainBadge onClick={(e) => e.preventDefault()}>{CURRENT_NETWORK_LABEL}</ChainBadge>
						</NavItem>
					</Row>
					<Row justifyContent="flex-end">
						<ThemeButton variant="primary" size="large" to="/request/create">
							New Request
						</ThemeButton>
						<NavItem>
							<ThemeIcon variant="layout" src={bell} onClick={() => setIsNotificationMenuOpen(true)} />
							{appState.notificationCount !== 0 && (
								<NotificationBadge isMobile={appState.isMobile}>
									{appState.notificationCount}
								</NotificationBadge>
							)}
						</NavItem>
						{GUIDES.find(
							(page) => location.pathname === page || (location.pathname.startsWith(page) && page !== '/')
						) &&
							location.pathname !== '/request/create' && (
								<NavItem>
									<ThemeIcon
										variant="layout"
										src={help}
										onClick={() => {
											localStorage.removeItem('guide/' + location.pathname.split('/')[1]);
											dispatch({
												type: actionTypes.SET_GUIDE_IS_OPEN,
												payload: true,
											});
										}}
									/>
								</NavItem>
							)}
						<NavItem isMobile={appState.isMobile} to="/settings/contacts">
							<ThemeIcon variant="layout" src={setting} />
						</NavItem>
						<NotificationMenu
							appState={appState}
							isOpen={isNotificationMenuOpen}
							onClose={() => {
								setIsNotificationMenuOpen(false);
							}}
						/>
					</Row>
				</NavBarRow>

				<BoxWrapper>
					<Box
						className={classes.root}
						as="header"
						mt="-1em"
						sx={{
							position: 'sticky',
							transform: sticky ? 'translateY(110px)' : 'translateY(0)',
							transition: 'transform 400ms ease-in',
							bottom: 0,
							left: 0,
						}}
					>
						{routeGroup === 'wallet' ? (
							<WalletTitlebar>
								<Title>Wallet</Title>
								<Balance>{`Balance: ${appState.biobitBalance} BBit`}</Balance>
							</WalletTitlebar>
						) : routeGroup === 'log' ? (
							<WalletTitlebar isMobile={appState.isMobile}>
								<Title>Log</Title>
								<RewardWrapper>
									<RewardItem>
										<RewardLabel>My reward from Zarela</RewardLabel>
										<RewardValue>{`${totalRevenueFromZarela} BBit`}</RewardValue>
									</RewardItem>
									<RewardItem>
										<RewardLabel>My wage from mage</RewardLabel>
										<RewardValue>{`${totalRevenueFromRequester} BBit`}</RewardValue>
									</RewardItem>
								</RewardWrapper>
							</WalletTitlebar>
						) : routeGroup === 'inbox' ? (
							<TitleBar>
								<Title>Inbox</Title>
							</TitleBar>
						) : routeGroup === 'settings' ? (
							<TitleBar>
								<Title>Settings</Title>
							</TitleBar>
						) : null}
					</Box>
				</BoxWrapper>
			</HeaderWrapper>
		);
	}
}
